import Vue from 'vue';
import VueI18n from 'vue-i18n';
Vue.use(VueI18n);

const messages = {
    'en': {
        appNavigation: {
            tours: 'Tours',
            aboutUs: 'About Us',
            contact: 'Contact',
            account: 'Account',
            login: 'Log In',
            signUp: 'Sign Up'
        },
        home: {
            ourTopTours: 'Our Top Tours',
            showAllTours: 'Show All Tours'
        },
        tours: {
            filters: 'Filters',
            region: 'Region',
            busan: 'Busan',
            geojae: 'Geojae',
            ulsan: 'Ulsan',
            gyungju: 'Gyungju',
            course: 'Course',
            timeOfDay: 'Time of Day',
            day: 'Day',
            night: 'Night',
            details: 'Details',
            itinerary: 'Itinerary',
            gamcheonculturevillage: 'Gamcheon Culture Village',
            songdobeach: 'Songdo Beach',
            yongdusanpark: 'Yongdusan Park',
            internationalmarket: 'International Market',
            biffplaza: 'BIFF Plaza',
            taejongdaepark: 'Taejongdae Park',
            busanchinatown: 'Busan Chinatown',
            dadaepobeach: 'Dadaepo Beach',
            amnampark: 'Amnam Park',
            jagalchimarket: 'Jagalchi Market',
            yeongdobridge: 'Yeongdo Bridge',
            seomyeonlottemall: 'Seomyeon Lotte Mall',
            jeonpocaferoad: 'Jeonpo Cafe Road',
            centumshinsegae: 'Centum Shinsegae',
            dongbaekisland: 'Dongbaek Island',
            nurimaru: 'Nurimaru',
            thebay101: 'The Bay 101',
            judistaehwaroad: 'Judis Taehwa Road',
            haeundaebeach: 'Haeundae Beach',
            busanhangbridge: 'BusanHang Beach',
            namhangbridge: 'Namhang Bridge',
            yachtstadium: 'Yacht Stadium',
            hwangnyeongsanbongsudae: 'Hwangnyeongsan Bongsudae',
            oryukdoskywalk: 'Oryukdo Skywalk',
            unitednationsmemorialcemetery: 'United Nations Memorial Cemetery',
            gwangallibeach: 'Gwangalli Beach',
            songjeongbeach: 'Songjeong Beach',
            haedongyonggungsa: 'Haedong Yonggungsa',
            yeonhwarivillage: 'Yeonghwari Village',
            daebyeonharbor: 'Daebyeon Harbor',
            waveoncafe: 'Wave On Cafe',
            ilgwangbeach: 'Ilgwang Beach',
            dalmajigil: 'Dalmaji Gil',
            gijangahopmountains: 'Gijang Ahop Mountains',
            lottepremiumoutlet: 'Lotte Premium Outlet',
            samkwangsachildrensgrandpark: "Samkwangsa Children's Grand Park",
            beomeosa: 'Beomeosa',
            gwanganbridge: 'Gwangan Bridge',
            busancinemacenter: 'Busan Cinema Center',
            geogabridge: 'Geoga Bridge',
            powcamphistoricpark: 'POW Camp Historic Park',
            gaeryongmountains: 'Gaeryong Mountains',
            haegeumgang: 'Haegeum Gang',
            oedobotania: 'Oedo Botania',
            ulsanganjeolgot: 'Ulsan Ganjeolgot',
            amethystcavernpark: 'Amethyst Cavern Park',
            daewangam: 'Daewangam',
            taehwagangsipliforest: 'Taehwagang Sipli Forest',
            jangsengpowhalecity: 'Jangsengpo Whale City',
            chumsungdae: 'Chumsungdae',
            chunmachong: 'Chunmachong',
            anapji: 'Anapji',
            bulguksa: 'Bulguksa',
            sukgulam: 'Sukgulam'
        },
        about: {
            aboutUs: 'About Us',
            intro: 'LimoTour Consulting is the best way for visitors and business to connect with the pulse of modern Korea. Since its establishment in 2009, LimoTour is proud of providing with global standard services to our valued customers maintaining powerful team equipped with long experiences from a variety of industries including hostility, event management, domestic travel, etc. Based on the accumulated know-how and its popularity thereof, many leading domestic and foreign companies in Korea chose Limo Tour as their long lasting partner.',
            companyHistory: 'Company History',
            history2017: '<ul><li class="my-2">17 November : Selected transportation agency for President of U.S Trump visits</li><li class="my-2">WBM group Pyungchang olympic broadcasting for 3years running</li><li class="my-2">Performing business U.S. Secretary of State Tillerson visits</li><li class="my-2">Performing business U.S. Vice president Mike Pence visits</li><li class="my-2">FIA Asia Pacific MotorSports Conference council(Supported by BMW)</li><li class="my-2">Dispatch chauffeur Ultra Music Festival V.I.P Transportation on 2016, 2017(Supported by Mercedes)</li><li class="my-2">Contacted with Olypic Brocasting Service for transportation</li><li class="my-2">Contracted with Apple Korea for V.I.P transportation</li><li class="my-2">Limousine service for Customer of Interparktour business class (2015~Present)</li></ul>',
            history2018: '<ul><li class="my-2">Performing business Jean-Marc Ayrault Prime Minister of France</li><li class="my-2">Performing business Princess of Qatar Siloviki</li><li class="my-2">Contracted with Airfrance for business class customer</li><li class="my-2">Performing business Vice president of UAE</li><li class="my-2">Performing business Groth summit conference Korea-China</li><li class="my-2">Performing business Minister of Denmark</li><li class="my-2">Performing business Kathleen Wynne Premier of Ontario, Canada</li></ul>'
        },
        contact: {
            contactInformation: 'Contact Information',
            address: 'Address',
            telephone: 'Telephone',
            fax: 'Fax',
            email: 'E-mail',
            messageUs: 'Message Us',
            name: 'Name',
            phoneNumber: 'Phone Number',
            message: 'Message',
            submit: 'Submit',
            limoTourAddress: '620, Haeun-daero, Haeundae-gu, Busan, Republic of Korea, Lamuette building 310'
        },
        footer: {
            company: 'Company',
            limotourBlog: 'Limotour Blog',
            aboutUs: 'About us',
            contact: 'Contact',
            services: 'Services',
            helpCenter: 'Help Center',
            termsAndConditions: 'Terms & Conditions',
            privatePolicy: 'Private Policy',
            partners: 'Partners',
            limoKorea: 'Limo Korea',
            others: 'Others',
            becomeAPartner: 'Become a Partner',
            addressFooter: 'LIMOTOUR : 32, Dasan-ro, Jung-gu, Seoul, Republic of Korea',
            phoneFooter: 'Client service：82-051-747-2040',
            emailFooter: 'E-mail: booking@limotourkorea.com',
            copyrightFooter: 'LimoTour Busan Korea Copyright reserved ©2020'
        }
    },
    'kr': {
        appNavigation: {
            tours: '투어코스',
            aboutUs: '회사소개',
            contact: '연락',
            account: '내계정',
            login: '로그인',
            signUp: '가입'
        },
        home: {
            ourTopTours: '인기투어',
            showAllTours: '투어코스 보기',
        },
        tours: {
            filters: '필터',
            region: '지역',
            busan: '부산',
            geojae: '거제',
            ulsan: '울산',
            gyungju: '경주',
            course: '코스',
            timeOfDay: '시간',
            day: '낮',
            night: '밤',
            details: '상세',
            itinerary: '여행 일정표',
            gamcheonculturevillage: '감천문화마을',
            songdobeach: '송도해수욕장',
            yongdusanpark: '용두산공원',
            internationalmarket: '국제시장',
            biffplaza: 'BIFF광장',
            taejongdaepark: '태종대',
            busanchinatown: '부산역차이나타운',
            dadaepobeach: '다대포해수욕장',
            amnampark: '암남공원',
            jagalchimarket: '자갈치시장',
            yeongdobridge: '영도대교',
            seomyeonlottemall: '서면롳데백화점',
            jeonpocaferoad: '전포카페거리',
            centumshinsegae: '센텀신세계',
            dongbaekisland: '동백섬',
            nurimaru: '누리마루',
            thebay101: '더베이101',
            judistaehwaroad: '서면쥬디스태화거리',
            haeundaebeach: '해운대해수욕장',
            busanhangbridge: '부산항대교',
            namhangbridge: '남항대교',
            yachtstadium: '요트경기장',
            hwangnyeongsanbongsudae: '황령산봉수대',
            oryukdoskywalk: '오륙도스카이워크',
            unitednationsmemorialcemetery: 'UN공원',
            gwangallibeach: '광안리해수욕장',
            songjeongbeach: '송정해수욕장',
            haedongyonggungsa: '해동용궁사',
            yeonhwarivillage: '연화리해녀촌',
            daebyeonharbor: '대변항',
            waveoncafe: '기장웨이브온카페',
            ilgwangbeach: '일광해수욕장',
            dalmajigil: '달맞이',
            gijangahopmountains: '기장아홉산숲',
            lottepremiumoutlet: '롯데프리미엄아울렛',
            samkwangsachildrensgrandpark: '삼광사어린이대공원',
            beomeosa: '범어사',
            gwanganbridge: '광안대교',
            busancinemacenter: '영화의 전당',
            geogabridge: '거가대교',
            powcamphistoricpark: '포로수용소',
            gaeryongmountains: '계룡산',
            haegeumgang: '해금강',
            oedobotania: '외도보타니아',
            ulsanganjeolgot: '울산간절곶',
            amethystcavernpark: '자수정동굴',
            daewangam: '대왕암',
            taehwagangsipliforest: '태화강십리대숲',
            jangsengpowhalecity: '장생포고래문화마을',
            chumsungdae: '첨성대',
            chunmachong: '천마총',
            anapji: '안압지',
            bulguksa: '불국사',
            sukgulam: '석굴암'
        },
        about: {
            aboutUs: '인사말',
            intro: '리모투어는 방문객들에게 현대 한국의 맥을 연결해 드리는 최고의 선택이 될 것입니다. 2009년에 설립된 리모투어는 환대 및 관리, 그리고 국내여행을 포함한 다양한 분야로부터의 전문가들이 포진되어 지속적이고도 향상된 글로벌 서비스를 제공해 드립니다. 축적된 경험과 노하우를 바탕으로 다수의 유수한 국내 및 외국 기업체들과 파트너로서의 역할을 수행하고 있습니다.',
            companyHistory: '회사 연혁',
            history2017: '<ul><li class="my-2">11월17일: 미국 트럼프 대통령 방문 차량 서비스 업체로 선정</li><li class="my-2">평창 올림픽 방송 WBM 그룹 담당 에이전트</li><li class="my-2">미국 틸러슨 비서실장 방문 담당 에이전트</li><li class="my-2">미국 마이크 펜스 부통령 방문 담당 에이전트</li><li class="my-2">FIA 아시아 태평양 모터스포츠 회의 교통 담당 에이전트(BMW 후원)</li><li class="my-2">울트라 뮤직 페스티발 VIP 쇼파 차량 배치 (벤츠 후원)</li><li class="my-2">Olympic Broadcasting Service와 차량 담당 계약</li><li class="my-2">애플 코리아 VIP 차량 담당 계약</li><li class="my-2">인터파크 여행사의 비즈니스 승객을 위한 리무진 서비스 (2015~현재)</li></ul>',
            history2018: '<ul><li class="my-2">프랑스 수상 쟝 마르크 아이롤트 담당 에이전트</li><li class="my-2">카타르 실로비키 왕자 담당 에이전트</li><li class="my-2">에어프랑스 비즈니스 승객 리무진 서비스 계약</li><li class="my-2">에티하드항공사 비즈니스 승객 리무진 서비스 계약</li><li class="my-2">UAE 부통령 담당 에이전트</li><li class="my-2">한중 Growth 정상회담 담당 에이전트</li><li class="my-2">덴마크 수상 담당 에이전트</li><li class="my-2">캐나타 온타리오 수상 캐트린 와인 담당 에이전트</li></ul>'
        },
        contact: {
            contactInformation: '문의 정보',
            address: '주소',
            telephone: '전화번호',
            fax: '펙스',
            email: '이메일',
            messageUs: '문의하기',
            name: '이름',
            phoneNumber: '전화번호',
            message: '메세지',
            submit: '제출',
            limoTourAddress: '부산광역시 해운대구 해운대로 620, 해운대 라뮤에뜨빌딩 310호'
        },
        footer: {
            company: '회사',
            limotourBlog: '리모투어 블로그',
            aboutUs: '회사 소개',
            contact: '연락',
            services: '서비스',
            helpCenter: '도움 센터',
            termsAndConditions: '조건',
            privatePolicy: '전용 정책',
            partners: '파트너',
            limoKorea: '리모코리아',
            others: '기타',
            becomeAPartner: '파트너 지원',
            addressFooter: '리모투어: 부산광역시 해운대구 해운대로 620, 해운대라뮤에뜨빌딩 310호',
            phoneFooter: '고객 서비스：82-051-747-2040',
            emailFooter: '이메일: booking-busan@limotourkorea.com',
            copyrightFooter: '리모투어 부산지점 저작권 보유 ©2020'
        }
    }
};
export default new VueI18n({
    locale: 'kr', // set locale
    fallbackLocale: 'en', // set fallback locale
    messages, // set locale messages
});
